import markerIcon from './marker-icon.png';
import markerIconRetina from './marker-icon-2x.png';
import markerShadow from './marker-shadow.png';

export const LEAFLET_ICONS = {
    markerIcon,
    markerIconRetina,
    markerShadow
} as const; 